/**
 * «Нуль не зникає» (Danyil 24.10.2026: «дуже багато жаліються — у полі стоїть
 * 0, і коли хочуть ввести, той нуль не зникає»).
 *
 * Перша лінія — у джерелі: NumInput показує нуль підказкою (`blankZero` за
 * замовчуванням), нові рядки форм — порожні з placeholder «0». Тут — страховка
 * на ВЕСЬ сайт для решти: числове поле, де стоїть голий нуль («0», «0.00»,
 * «0,0»), при фокусі виділяється — перша цифра замінює нуль, а не дописується
 * до нього («05», «0,5»). Одне місце замість латок на кожному екрані.
 */
const BARE_ZERO = /^\s*0+([.,]0*)?\s*$/;

export function isNumericField(el: EventTarget | null): el is HTMLInputElement {
  if (!(el instanceof HTMLInputElement)) return false;
  return el.type === "number" || el.inputMode === "decimal" || el.inputMode === "numeric";
}

export function isBareZero(v: string): boolean {
  return BARE_ZERO.test(v);
}

export function installZeroSelect(doc: Document = document): void {
  doc.addEventListener("focusin", (e) => {
    const el = e.target;
    if (!isNumericField(el) || !isBareZero(el.value)) return;
    // Після фокуса: на телефоні виділення, поставлене в самому focus, браузер
    // скидає власним розміщенням курсора.
    requestAnimationFrame(() => {
      try { el.select(); } catch { /* поле зникло — нічого виділяти */ }
    });
  });
}
